import { useTranslation } from "react-i18next";
import styles from "./States.module.css";

/**
 * The shared "permission denied" state for a single action or panel within an otherwise usable
 * screen — distinct from the shell-level `UR-V-01` "this service is not for you" notice, which
 * covers a whole account being ineligible. This is for an eligible, signed-in person who lacks
 * one specific permission (`Rws.AiInsights.Host.Authorization.PortalProblems.PermissionDenied`).
 *
 * @param props.title - Overrides the default heading.
 * @param props.description - Overrides the default explanatory text.
 */
export function PermissionDeniedState({
  title,
  description,
}: {
  title?: string;
  description?: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={`${styles.panel} ${styles.permissionDenied}`} role="status">
      <h2>{title ?? t("states.permissionDenied.defaultTitle")}</h2>
      <p className={styles.description}>{description ?? t("states.permissionDenied.defaultDescription")}</p>
    </div>
  );
}
